import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FtoReportImportPatentsModel } from '../import-patents-model';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { ImportPatentsState } from '../import-patents-model';
import { createInitialImportPatentsStatus } from '../../repositories/impls/import-patents-repository';

const createInitialImportPatentsState = (): ImportPatentsState => {
    return createInitialImportPatentsStatus();
};

@injectable()
export class FtoReportImportPatentsModelImpl extends AbstractModel<ImportPatentsState> implements FtoReportImportPatentsModel {
    protected _modelData: ImportPatentsState = createInitialImportPatentsState();

    dispose(): void {
        this.update(() => {
            return createInitialImportPatentsState();
        });
    }

}
